import React, { useState, useEffect } from 'react';
import axios from 'axios';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';

const Session3 = () => {
  const [sessiontopic, setSessionTopic] = useState('');
  const [name, setName] = useState('');
  const [question, setQuestion] = useState('');
  const [isSessionActive, setIsSessionActive] = useState(false);
  const [sessionData, setSessionData] = useState(null);
  const [questionCount, setQuestionCount] = useState(0);
  const [maxQuestionsReached, setMaxQuestionsReached] = useState(false);

  console.log(sessionData);

  useEffect(() => {
    axios.get('https://rvapi.emedha.in/pages/api/session3/sessiontiming')
      .then(response => {
        console.log('Session response: ', response.data);
        if (response.data.activeSession) {
          setIsSessionActive(true);
          setSessionData(response.data.session);
          setSessionTopic(response.data.session.sessiontopic);
          checkQuestionCount(response.data.session.sessiontopic);
        } else {
          setIsSessionActive(false);
        }
      })
      .catch(error => {
        console.error('Error fetching session data:', error);
        setIsSessionActive(false);
      });
  }, []);

  const checkQuestionCount = (topic) => {
    axios.get(`https://rvapi.emedha.in/pages/api/get/questions?sessiontopic=${topic}`)
      .then(response => {
        const count = response.data.filter(item => item.sessiontopic === topic).length;
        setQuestionCount(count);
        if (count >= 10) {
          setMaxQuestionsReached(true);
        }
      })
      .catch(error => {
        console.error('Error fetching question count:', error);
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (questionCount >= 10) {
      alert('The maximum number of questions (10) for this session has been reached.');
      return;
    }

    try {
      const response = await axios.post('https://rvapi.emedha.in/pages/api/submit', {
        sessiontopic: sessiontopic,
        name: name,
        question: question
      });

      console.log('Response:', response.data);
      alert('Question submitted successfully!');
      setName('');
      setQuestion('');
      setQuestionCount(questionCount + 1); 
    } catch (err) {
      console.error('Error submitting question:', err);
      alert('Failed to submit question.');
    }
  };

  return (
    <>
      <div className="mt-1">
        <img src={H1} alt="item" style={{ height: '230px', width: '100%' }} />

        <div className='mt-2'>
          <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px' }}>
            <div style={{ textAlign: 'center' }}>
              <button style={{ margin: '5px', padding: '10px 20px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '16px' }}>
              Panel Discussion
              </button>
            </div>

            {isSessionActive && !maxQuestionsReached && (
              <form onSubmit={handleSubmit} style={{ backgroundColor: '#f4f4f9', padding: '20px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', marginTop: '20px' }}>
                <div>
                  <div>
                    <label htmlFor="sessiontopic" style={{ display: 'block' }}>Session Topic</label>
                    <input type="text" id="sessiontopic" name="sessiontopic" required value={sessiontopic} readOnly style={{ width: '100%', padding: '8px', margin: '8px 0', borderRadius: '5px', border: '1px solid #ccc' }} />
                  </div>
                  <div>
                    <label htmlFor="name" style={{ display: 'block' }}>Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      style={{ width: '100%', padding: '8px', margin: '8px 0', borderRadius: '5px', border: '1px solid #ccc' }}
                    />
                  </div>
                  <div>
                    <label htmlFor="question" style={{ display: 'block' }}>Question</label>
                    <textarea
                      type="text"
                      id="question"
                      name="question"
                      required
                      value={question}
                      onChange={(e) => setQuestion(e.target.value)}
                      style={{ width: '100%', padding: '8px', margin: '8px 0', borderRadius: '5px', border: '1px solid #ccc' }}
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  style={{ padding: '10px 20px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '16px', width: '100%' }}>
                  Submit
                </button>
              </form>
            )}

            {!isSessionActive && (
              <p style={{ color: 'red', textAlign: 'center' }}>The Panel Discussion session is not currently active. Please check back later.</p>
            )}

            {maxQuestionsReached && (
              <p style={{ color: 'red', textAlign: 'center' }}>The maximum number of questions for this session has been reached. Please check back for future sessions.</p>
            )}
          </div>
        </div>

        <footer style={{ backgroundColor: '#f1f1f1', padding: '10px 0', textAlign: 'center', marginTop: '20px' }}>
          <div>
            <p style={{ margin: '0', fontSize: '14px' }}>Powered by
              <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px' }}>
                EMedha Technologies
              </a>
            </p>
            <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
              <img src={L1} alt="EMedha Technologies Logo" style={{ width: '200px', height: 'auto', marginTop: '10px' }} />
            </a>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Session3;
